import styled from "styled-components";

const FieldWrapper = styled.div`
  font-family: ${({ theme }) => theme.font};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 24px;
`;

export default FieldWrapper;
